export const REGEXP_NUMBER_END_LETTER = '^(^[0-9]*$)|(^[A-Za-z]+$)|(^[0-9A-Za-z]*$)'
export const REGEXP_PHONE = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/